import { useEffect } from 'react';

import { getAppGlobals } from '~/components/AppGlobals/utils';

const HumanEmbed = () => {
  const appGlobals = getAppGlobals();

  useEffect(() => {
    if (appGlobals.VITE_HUMAN_ENABLED !== 'true') return;

    try {
      const humanScript = document.createElement('script');
      humanScript.src = appGlobals.VITE_HUMAN_URL || '';
      humanScript.async = true;
      document.head.appendChild(humanScript);

      return () => {
        if (document.head.contains(humanScript)) {
          document.head.removeChild(humanScript);
        }
      };
    } catch (error) {
      console.error('Error loading Human script:', error);
    }
  }, [appGlobals]);

  return null;
};

export default HumanEmbed;
